module.exports = __webpack_public_path__ + "img/75613.68a23eaf.svg";